import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbIconConfig, NbToastrService } from '@nebular/theme';
import { AuthService, UsersService } from 'app/openapi-auth/services';
import { ProductsService } from 'app/openapi-hq/services';

import { LocalDataSource } from 'ng2-smart-table';

@Component({
  selector: 'ntgr-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent {

  private compareDate = (value) => value ? new Date(value).getTime() : 0;

  settings = {
    mode: 'external',
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },    
    actions: {
      add: true,
      edit: true,
      delete: true,      
    },
    columns: {
      name: {
        title: 'Name',
        type: 'string',
      },
      itemNumber: {
        title: 'ItemNumber',
        type: 'string',
      },
      type:{
        title: 'Type',
        type: 'string',
      },
      status: {
        title: 'Status',
        type: 'string',
      }
    },
    pager: {
      perPage: 50,
    }
  };

  source = new LocalDataSource();
  private removedIcon: NbIconConfig = { icon: 'person-remove-outline', pack: 'eva' };
  private modifiedIcon: NbIconConfig = { icon: 'person-done-outline', pack: 'eva' };

  constructor(private productsService: ProductsService, private toastService: NbToastrService, private router: Router) {
    this.loadDataFromServer();    
  }

  loadDataFromServer() {
    this.productsService.productsGet().subscribe((products) => {
      this.source.load(products).then(() => {
        
      });
    });

  }

  successMsg(msg: string, icon: NbIconConfig) {
    this.toastService.show(msg, "Success!", {hasIcon: true, status: 'success', ...icon});
  }

  errorMsg(msg: string, icon: NbIconConfig) {
    this.toastService.show(msg, "Error!", {hasIcon: true, status: 'danger', ...icon})
  }

  onDeleteConfirm(event): void {
    if (window.confirm('Are you sure you want to delete record?')) {
      event.confirm.resolve();
    } else {
      event.confirm.reject();
    }
  }

  onSort(event) {
    console.log(event);
  }

  onCreate() {
    this.router.navigate(['products', "new"]);
  }

  onEdit(event) {
    const {data} = event;
    this.router.navigate(['products', "edit", data._id]);
  }

  onDelete(event) {
    const {data} = event;
    this.productsService.productDelete({id: data._id}).subscribe(response => {
      if (response.message === "ok") {
        this.successMsg("Record successfully deleted", {icon: "checkmark-outline", pack: 'eva'});
        this.loadDataFromServer();
      }
    })
  }

}
